export default __webpack_public_path__ + "static/media/dumbbell.db43313d.png";